import * as React from 'react';
import { NString } from '@mobalytics/shared';
import { PaymentConfirmationLayout } from '../../../payment-confirmation-layout/payment-confirmation-layout.component';
import { AllowedActionsT } from '../../../../payment.types';
import { useStripeFlowConfirmationInfo } from '../stripe-flow-confirmation-info.hook';
import { StripeFlowElementsProvider } from '../stripe-flow-elements-provider.component';
import { StripeExistingFlowConfirmation } from './stripe-existing-flow-confirmation/stripe-existing-flow-confirmation.component';
import { SavedPaymentInfo } from './saved-payment-info/saved-payment-info.component';

interface Props {
  className?: string;
  // data
  title: string;
  description: string;
  submitButtonLabel: string;

  planId: string;
  productAbbreviation: string;
  coupon: NString;
  allowedActions: AllowedActionsT;
}

export const StripeExistingFlow: React.FC<Props> = (props) => {
  const { className, title, description, submitButtonLabel, coupon, allowedActions, planId, productAbbreviation } =
    props;
  const { loading, fetchConfirmationInfo, confirmationInfo } = useStripeFlowConfirmationInfo({
    planId,
    productAbbreviation,
    coupon,
    allowedActions,
  });
  return (
    <div className={className}>
      <PaymentConfirmationLayout
        className={className}
        loading={loading || !!confirmationInfo}
        buttonLabel={submitButtonLabel}
        onSubmit={() => fetchConfirmationInfo(false)}
        errorMessage={null}
      >
        <SavedPaymentInfo title={title} description={description} />
        {confirmationInfo && (
          <StripeFlowElementsProvider confirmationInfo={confirmationInfo}>
            <StripeExistingFlowConfirmation confirmationInfo={confirmationInfo} />
          </StripeFlowElementsProvider>
        )}
      </PaymentConfirmationLayout>
    </div>
  );
};
